import React, { useState } from 'react';
import LazyImage from '../LazyImage';
import './Teams.css';
import team1 from '../../assets/images/team1.webp';
import team2 from '../../assets/images/team2.webp';
import team3 from '../../assets/images/team3.webp';
import team4 from '../../assets/images/team4.webp';
import leftIcon from '../../assets/icons/left.png';
import rightIcon from '../../assets/icons/right.png';

const Teams = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const teamMembers = [
        {
            name: "Lisa Tran",
            designation: "Superannuation Specialist",
            image: team1
        },
        {
            name: "David Rowe",
            designation: "Client Services Manager",
            image: team2
        },
        {
            name: "John Matthews",
            designation: "Principal Accountant",
            image: team3
        },
        {
            name: "Emily Foster",
            designation: "Business Advisor",
            image: team4
        },
        {
            name: "Lisa Tran",
            designation: "Superannuation Specialist",
            image: team1
        },
        {
            name: "David Rowe",
            designation: "Client Services Manager",
            image: team2
        },
        {
            name: "John Matthews",
            designation: "Principal Accountant",
            image: team3
        },
        {
            name: "Emily Foster",
            designation: "Business Advisor",
            image: team4
        },
    ];

    const goToPrevious = () => {
        setCurrentIndex(currentIndex === 0 ? teamMembers.length - 1 : currentIndex - 1);
    };

    const goToNext = () => {
        setCurrentIndex(currentIndex === teamMembers.length - 1 ? 0 : currentIndex + 1);
    };

    const getVisibleTeamMembers = () => {
        const visible = [];
        for (let i = -1; i <= 4; i++) {
            const index = (currentIndex + i + teamMembers.length) % teamMembers.length;
            visible.push(teamMembers[index]);
        }
        return visible;
    };

    return (
        <section className="teams">
            <div className="teams-container">
                <div className="teams-content">
                    <div className="teams-header">
                        <div className="teams-tag">Meet The Team</div>
                        <h2 className="teams-title">
                            The People <span className="text-primary">Behind PFGS</span>
                        </h2>
                        <p className="teams-description">
                            Our strength lies in our people. With decades of combined experience and a passion
                            for helping businesses thrive, our team brings the knowledge, care, and clarity you
                            deserve.
                        </p>
                    </div>

                    <div className="teams-cards-wrapper">
                        <div className="teams-cards">
                            {getVisibleTeamMembers().map((member, index) => (
                                <div key={`${member.name}-${index}`} className="team-card">
                                    <div className="team-image">
                                        <LazyImage src={member.image} alt={member.name} />
                                    </div>
                                    <div className="team-info">
                                        <h3 className="team-name">{member.name}</h3>
                                        <p className="team-designation">{member.designation}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="teams-navigation">
                        <button className="nav-button" onClick={goToPrevious}>
                            <img src={leftIcon} alt="Previous" className="nav-icon" />
                        </button>
                        <button className="nav-button" onClick={goToNext}>
                            <img src={rightIcon} alt="Next" className="nav-icon" />
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Teams;